var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"supplier-capacity-table-container"},[_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.capacityTableData,"pagination":false,"scroll":{x:100,y:_vm.cusHeight}},scopedSlots:_vm._u([{key:"avgLoad",fn:function(text){return [_c('span',[_vm._v(_vm._s(`${parseFloat((Number(text) * 100).toFixed(4))}%`))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }